import React from 'react';

const Event = ({event}) => {
  let { courseName, startTime, endTime, locationLine1, locationLine2} = event;
  return (
    <div className="eventWrapper" title={`${courseName} - ${startTime} to ${endTime}`}>
      <div className="event-header">
        <h4 className="event-title">{courseName}</h4>
      </div>
      <div className="event-details">
        <p className="event-time">{`${startTime} - ${endTime}`}</p>
        {locationLine1 && (
          <p className="event-location">{locationLine1}</p>
        )}
        {locationLine2 && (
          <p className="event-location">{locationLine2}</p>
        )}
      </div>
    </div>
  )
}

export default Event;